import SplitPanelRouter from './SplitPanelRouter';
export default SplitPanelRouter;
